<template>
  <div class="curtainText">
    <div v-html="formattedString"></div>
    <button
      v-show="text.length > maxChars + buffer"
      v-on:click="readingMore = !readingMore"
      class="learn-more-link"
    >
      <svg v-show="readingMore" class="fa-symbol startOfTextLinkIcon">
        <use xlink:href="#angle-double-left"></use>
      </svg>
      {{ readMoreLinkText }}
      <svg v-show="!readingMore" class="fa-symbol endOfTextLinkIcon">
        <use xlink:href="#angle-double-right"></use>
      </svg>
    </button>
  </div>
</template>

<script>
import faSymbol from "../mixins/faSymbol";

export default {
  name: "curtainText",
  props: {
    moreStr: {
      type: String,
      default: "Read more",
    },
    lessStr: {
      type: String,
      default: "Read less",
    },
    text: {
      type: String,
      required: true,
    },
    maxChars: {
      type: Number,
      default: 100,
    },
    buffer: {
      type: Number,
      default: 100,
    },
  },
  mixins: [faSymbol],
  data() {
    return {
      readingMore: false,
    };
  },
  created: function () {
    this.createSymbol("angle-double-right");
    this.createSymbol("angle-double-left");
  },
  computed: {
    formattedString() {
      return !this.readingMore && this.text.length > this.maxChars + this.buffer
        ? this.text.substr(0, this.text.lastIndexOf(" ", this.maxChars)) + "..."
        : this.text;
    },
    readMoreLinkText() {
      return this.readingMore ? this.lessStr : this.moreStr;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
@import "../../styles/mixins";

.curtainText > * {
  display: inline;
}
button {
  align-items: normal;
  background-color: rgba(0, 0, 0, 0);
  border: none;
  box-sizing: content-box;
  color: $link;
  word-wrap: break-word;
  cursor: pointer;
  display: inline;
  font: inherit;
  font-weight: $bold-weight;
  height: auto;
  padding: 0;
  perspective-origin: 0 0;
  text-align: start;
  text-decoration: none;
  transform-origin: 0 0;
  width: auto;

  &:hover,
  &:focus {
    cursor: pointer;
    color: $link--hover;
  }
}
</style>
